import React, { useEffect, useState } from 'react';
import { ArrowsRotateRight } from '@gravity-ui/icons';
import { DateTimeInput } from '../../../components/DateTimeInput';
import { PRESETS } from '../summaryPeriods';
import { toIsoWithOffset, toLocalInputValue } from '../../../utils/toIsoWithOffset';

/**
 * ТЗ №1 §7.1–7.2. Presets пишут preset+from+to в URL; custom — from/to из
 * DateTimeInput через toIsoWithOffset (timezone-aware). Custom держит
 * локальный draft, чтобы запрос уходил только по «Применить».
 *
 * FE-FIX18: выбор объекта здесь больше не живёт — объекты, подразделения,
 * области, локации, камеры и правила выбираются общим ScopeFilter, который
 * умеет несколько значений. Здесь остался только период.
 */
const SummaryFilters = ({
  preset, from, to, onChange, onRefresh, disabled = false, validationError = '',
}) => {
  const [draftFrom, setDraftFrom] = useState(from ? toLocalInputValue(from) : '');
  const [draftTo, setDraftTo] = useState(to ? toLocalInputValue(to) : '');

  useEffect(() => { setDraftFrom(from ? toLocalInputValue(from) : ''); }, [from]);
  useEffect(() => { setDraftTo(to ? toLocalInputValue(to) : ''); }, [to]);

  const applyCustom = () => onChange({
    preset: 'custom',
    from: toIsoWithOffset(draftFrom) || '',
    to: toIsoWithOffset(draftTo) || '',
  });

  return (
    <div className="sum-filters">
      <div className="sum-field">
        <span className="sum-field-label">Период</span>
        <div className="sum-segment" role="group" aria-label="Период">
          {PRESETS.filter((item) => item.id !== 'custom').map((item) => (
            <button
              key={item.id}
              type="button"
              disabled={disabled}
              className={`sum-preset${preset === item.id ? ' sum-preset--active' : ''}`}
              onClick={() => onChange({ preset: item.id })}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="sum-field sum-field--custom">
        <span className="sum-field-label">Произвольный период</span>
        <div className="sum-custom">
          <DateTimeInput id="sum-from" value={draftFrom} onChange={setDraftFrom} ariaLabel="Начало периода" />
          <span className="sum-custom-dash">—</span>
          <DateTimeInput id="sum-to" value={draftTo} onChange={setDraftTo} ariaLabel="Конец периода" />
          <button
            type="button"
            className={`sum-btn${preset === 'custom' ? ' sum-btn--active' : ''}`}
            disabled={disabled || !draftFrom || !draftTo}
            onClick={applyCustom}
          >
            Применить
          </button>
        </div>
        {validationError && <p className="sum-field-error">{validationError}</p>}
      </div>

      <button
        type="button"
        className="sum-btn sum-btn--square sum-refresh"
        disabled={disabled}
        onClick={onRefresh}
        title="Обновить"
        aria-label="Обновить"
      >
        <ArrowsRotateRight width={16} height={16} />
      </button>
    </div>
  );
};

export default SummaryFilters;
